<script>

import apiService from '../../services/api-service.js';

/**
 * Requires inline template
 * found at resources/views/partials/ticket-details-status-form.blade.php
 */
export default {
  props: [
    'apiUrl',
    'ticketId',
  ],
  data() {
    return {
      statusRef: 0,
      statusDesc: "",
      tecnicoUserId: 0,
      tecnicoUserName: "",
      clienteUserId: 0,
      clienteUserName: "",
      deInteresGeneral: false,
      isLoading: false,
      hasChanged: false
    };
  },
  created() {
    this.submit(false);
  },
  methods: {
    onChange() {
      this.statusDesc = ''
      this.refreshStatusIconTooltip();
      this.hasChanged = true;
    },
    submit(doPost) {
      this.isLoading = true;
      axios({
        method: doPost ? 'post' : 'get',
        url: this.apiUrl + '/ticket/' + this.ticketId + '/status',
        data: doPost ? {
          ticketId: this.ticketId,
          statusRef: this.statusRef,
          tecnicoUserId: this.tecnicoUserId,
          clienteUserId: this.clienteUserId,
          deInteresGeneral: this.deInteresGeneral,
        } : {
        }
      }).then(response => {
        if(response.data.status == apiService.STATUS_OK) {
          if(doPost) {
            location.reload();
          } else {
            this.isLoading = false;
            this.statusRef = response.data.statusRef;
            this.statusDesc = response.data.statusDesc;
            this.tecnicoUserId = response.data.tecnicoUserId;
            this.tecnicoUserName = response.data.tecnicoUserName;
            this.clienteUserId = response.data.clienteUserId;
            this.clienteUserName = response.data.clienteUserName;
            this.deInteresGeneral = response.data.deInteresGeneral;
            this.refreshStatusIconTooltip();
            this.hasChanged = false;
          }
        } else {
          this.isLoading = false;
          console.log("Ajax response error: " + response.data.message);
        }
      }).catch(error => {
        this.isLoading = false;
        console.log(error);
      });
      return false;
    },
    refreshStatusIconTooltip() {
      $(this.$refs['status-icon'])
      .attr('data-original-title', this.statusDesc)
    }
  },
  components: {
    "ticket-status-progress-bar": {
      props: [
        "postUrl",
        "statusRef"
      ],
      data() {
        return {
          innerHtml: ""
        }
      },
      created() {
        this.onStatusRefChange();
      },
      watch: {
        statusRef(val, oldval) {
          this.onStatusRefChange();
        }
      },
      methods: {
        onStatusRefChange() {
          axios({
            method: "post",
            url: this.postUrl,
            params: {
              statusRef: this.statusRef
            }
          }).then(response => {
            if(response.data.status = apiService.STATUS_OK) {
              this.innerHtml = response.data.html;
            }
          });
        }
      }
    }
  }
};
</script>
